module.exports = __webpack_public_path__ + "static/media/logo.f497f367.svg";